module.exports = __webpack_public_path__ + "media/images/beauty/main_image1@3x-d93b4d21f122e016af88428a6c0aaea4.jpg";